import React, { useEffect, useState } from 'react'
import { Get_Custom_Designs, custom_jewellery } from '../../../../api/global/Global'
import { IMG_BASE_URL } from '../../../../config/Config'
import { isValidEmail } from '../../../validation/Validation';
import { toast } from 'react-toastify';

const Home_Exclusive_Design = () => {
    const [isOpen_Custom_video, set_Is_Open_Custom_Video] = useState(false);
    const [customDesigns, setCustomdesigns] = useState(null)
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedDesignId, setSelectedDesignId] = useState(null);
    const [modalForm, setModalForm] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        country_code: '+91' // Default country code
    });
    const Handle_Is_Open_Custom_video = (videoUrl) => {
        set_Is_Open_Custom_Video(!isOpen_Custom_video);
        setSelectedVideo(videoUrl)
    };

    // Handle modal form input changes
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone" && value.length > 10) {
            return
        }

        if (name === "email") {
            if (!isValidEmail(value)) {
                setErrorMessage("Please enter a valid email address");
            } else {
                setErrorMessage("");
            }
        }
        setModalForm(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const resetMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
    };

    const handleWriteToUs = (designId) => {
        setSelectedDesignId(designId);
        setShowModal(true);
        resetMessages();
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        resetMessages();

        if (!modalForm.email || !isValidEmail(modalForm.email)) {
            toast("Please enter a valid email address.");
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', modalForm.name);
            formData.append('email', modalForm.email);
            formData.append('country_code', modalForm.country_code);
            formData.append('mobile', modalForm.phone);
            formData.append('message', modalForm.message);

            if (selectedDesignId) {
                formData.append('custom_design_id', selectedDesignId?.id);
            }

            const response = await custom_jewellery({
                method: 'POST',
                body: formData,
            })

            // Adjust based on your API response structure
            const result = response.data;

            if (result?.status == 200) {
                setSuccessMessage(result?.message || 'Your request has been submitted successfully!');
                setModalForm({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    country_code: '+91'
                });

                setTimeout(() => {
                    setShowModal(false);
                    setSuccessMessage('');
                }, 2000);
            }
            if (response?.response?.data?.status == 500) {
                setErrorMessage(response?.response?.data?.message || 'Failed to submit your request.');
            }
        } catch (error) {
            console.error('Error submitting modal form:', error);
            setErrorMessage('Failed to submit your request. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const closePopUp = () => {
        setShowModal(false)
        setModalForm({
            name: '',
            email: '',
            phone: '',
            message: '',
            country_code: '+91'
        });

    }

    useEffect(() => {
        const getcustom_designs = async () => {
            try {
                const response = await Get_Custom_Designs()
                if (response?.data?.status == 200) {
                    setCustomdesigns(response?.data?.data?.custom_design)
                }

            } catch (error) {
                console.error(error.message);

            }
        }
        getcustom_designs()
    }, [])

    useEffect(() => {
        if (showModal || isOpen_Custom_video) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showModal, isOpen_Custom_video]);

    const customDesignFix = customDesigns?.slice(0, 8)

    return (
        <div>
            <section className="gi-deal-section bg-[#f1f1f1] py-[40px] max-[767px]:py-[30px] wow fadeInUp" data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[770px] min-[576px]:max-w-[560px]">
                    <div className="w-full flex flex-wrap px-[12px] overflow-hidden">
                        <div className="gi-deal-section w-full">
                            <div className="gi-products">
                                <div className="section-title mb-[20px] relative text-center pb-[20px] z-[5]" data-aos="fade-up"
                                    data-aos-duration="2000" data-aos-delay="200">
                                    <div className="section-detail">
                                        <h2
                                            className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                            Exclusive Custom Designs</h2>
                                        <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">Artistic Expression in Terms
                                            of Jewellery</p>
                                    </div>

                                </div>
                                <div className="gi-deal-block" data-aos="fade-up" data-aos-duration="2000"
                                    data-aos-delay="300">
                                    <div
                                        className="custome_jewellery grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1">
                                        {
                                            customDesignFix?.map((designs) => (

                                                <div className="gi-products bg-no-repeat text-center bg-cover h-[300px] overflow-hidden"
                                                    style={{
                                                        backgroundImage: `url(${IMG_BASE_URL}/${designs?.thumbnail_img})`, // Add your image URL here
                                                    }}
                                                >
                                                    <div
                                                        className="bg-gradient-to-t relative from-[#000] opacity-0 hover:opacity-100 p-5 flags h-full">

                                                        {designs?.video && (
                                                            <button onClick={() => { Handle_Is_Open_Custom_video(`${IMG_BASE_URL}${designs?.video}`) }}>
                                                                <div
                                                                    className="absolute w-12 rounded-full leading-[52px] h-12 bg-white m-auto left-0 right-0 top-0 bottom-0">
                                                                    <i className="fi-rr-play" ></i>
                                                                </div>
                                                            </button>
                                                        )}

                                                        <button className="absolute bottom-0 left-0 w-full" >
                                                            <div
                                                                className=" inset-center text-white mx-4 mb-4 border px-3 text-sm rounded-full py-2 hover:bg-[#9F2225] hover:border-gray-900" onClick={() => handleWriteToUs(designs)}>
                                                                Write to us</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <-------- Modal section's Custome Video ----------> */}
            {
                isOpen_Custom_video && selectedVideo && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-[4px] animate-videoFadeIn" onClick={Handle_Is_Open_Custom_video}>
                        <style>{`
                          @keyframes videoFadeIn {
                            from { opacity: 0; }
                            to { opacity: 1; }
                          }
                          @keyframes videoScaleUp {
                            from { transform: scale(0.95); opacity: 0; }
                            to { transform: scale(1); opacity: 1; }
                          }
                          .animate-videoFadeIn {
                            animation: videoFadeIn 0.2s ease-out forwards;
                          }
                          .animate-videoScaleUp {
                            animation: videoScaleUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                          }
                        `}</style>

                        {/* <!-- Modal Content --> */}
                        <div className="bg-white rounded-2xl shadow-2xl max-w-xl w-full overflow-hidden border border-gray-100 relative animate-videoScaleUp" onClick={(e) => e.stopPropagation()}>
                            {/* <!-- Modal Header --> */}
                            <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
                                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider">Custom Video</h3>
                                <button className="text-gray-400 hover:text-gray-600 transition-colors duration-200 text-2xl font-light leading-none" onClick={Handle_Is_Open_Custom_video}>
                                    &times;</button>
                            </div>

                            {/* <!-- Modal Body --> */}
                            <div className="bg-black aspect-video flex items-center justify-center">
                                <video controls autoPlay className="w-full h-full object-contain">
                                    <source src={selectedVideo} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                )
            }

            <div className={`p-4 sm:p-6 ${!showModal ? 'hidden' : 'flex'} fixed inset-0 z-[9999] bg-black/75 backdrop-blur-[3px] items-center justify-center overflow-y-auto`}>
                <style>{`
                  @keyframes scaleUp {
                    from { transform: scale(0.95); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                  }
                  .animate-scaleUp {
                    animation: scaleUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                  }
                `}</style>

                {/* Modal Container */}
                <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl relative overflow-hidden border border-gray-100 flex flex-col my-8 animate-scaleUp">
                    {/* Close Button */}
                    <button
                        onClick={closePopUp}
                        className="absolute top-4 right-4 z-10 font-light text-2xl text-gray-400 hover:text-gray-600 active:scale-90 transition-all duration-200"
                        aria-label="Close modal"
                    >
                        &times;
                    </button>

                    {/* Modal Header */}
                    <div className="bg-gradient-to-r from-[#9F2225]/5 to-[#723F25]/5 px-6 py-5 border-b border-gray-100 pr-12">
                        <h3 className="text-lg font-bold text-gray-900 leading-tight">Submit Your Request</h3>
                        <p className="text-gray-500 text-xs font-medium mt-0.5">
                            {selectedDesignId?.title || selectedDesignId?.name || "18K Yellow Gold Blue Sapphire With Diamond Ring"}
                        </p>
                    </div>

                    {/* Modal Body */}
                    <div className="p-6 overflow-y-auto max-h-[calc(100vh-180px)]">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                            {/* Image side */}
                            <div className="w-full flex items-center justify-center bg-gray-50 rounded-xl overflow-hidden border border-gray-100 p-2">
                                <img
                                    className="w-full h-auto max-h-[300px] object-contain rounded-lg"
                                    src={`${IMG_BASE_URL}${selectedDesignId?.thumbnail_img}`}
                                    alt="jewellery"
                                />
                            </div>

                            {/* Form side */}
                            <div>
                                <form onSubmit={handleModalSubmit} className="space-y-4">
                                    <div>
                                        <label className="text-gray-700 font-medium text-xs block mb-1">Name</label>
                                        <input
                                            type="text"
                                            placeholder="Enter your name"
                                            name="name"
                                            value={modalForm.name}
                                            onChange={handleModalInputChange}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-700 font-medium text-xs block mb-1">Email ID</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter your e-mail here"
                                            value={modalForm.email}
                                            onChange={handleModalInputChange}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-700 font-medium text-xs block mb-1">Phone Number</label>
                                        <input
                                            type="number"
                                            name="phone"
                                            placeholder="Enter Your Phone Number Here"
                                            value={modalForm.phone}
                                            onChange={handleModalInputChange}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-10 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-700 font-medium text-xs block mb-1">Message</label>
                                        <textarea
                                            placeholder="Enter Your Message Here"
                                            name="message"
                                            rows="3"
                                            value={modalForm.message}
                                            onChange={handleModalInputChange}
                                            className="w-full border border-gray-300 rounded-lg p-3 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none resize-none"
                                            required
                                        />
                                    </div>

                                    {successMessage && (
                                        <div className="bg-green-50 border border-green-200 text-green-700 px-3 py-2.5 rounded-lg text-xs font-semibold animate-pulse">
                                            {successMessage}
                                        </div>
                                    )}

                                    {errorMessage && (
                                        <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2.5 rounded-lg text-xs font-semibold">
                                            {errorMessage}
                                        </div>
                                    )}

                                    <div className="pt-2">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="w-full px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#9F2225] hover:bg-[#851d20] active:scale-98 transition-all duration-200 shadow-md shadow-red-900/10 uppercase tracking-wider"
                                        >
                                            {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* popup end */}

        </div>
    )
}

export default Home_Exclusive_Design